module.exports = __webpack_public_path__ + "3f16e137/img/grid-web-icon.d0395d64.svg";